<template>
  <div>
    <!-- サイドメニュー -->
    <v-navigation-drawer v-model="drawer" class="indigo" app width="300">
      <v-container>

        <v-list-item >
            <div class="usr-name white--text">{{ menuInfo1 }}<br/>{{ menuInfo2 }}</div>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense nav>
          <v-list-item v-for="menuInfo in menuInfoList" :key="menuInfo.name" @click="clickMenuAction(menuInfo.name, menuInfo.link)">
            <v-list-item-icon>
              <v-icon large>{{ menuInfo.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="menu-title white--text">{{ menuInfo.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-container>
    </v-navigation-drawer>

    <!-- グローバルナビゲーション -->
    <v-app-bar app color="#ffffff">
      <v-app-bar-nav-icon @click="drawer = !drawer"> </v-app-bar-nav-icon>
      <v-toolbar-title>
        <div class="scn-name">{{ toolbarTitle }}</div>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <div>
        <v-img src="../assets/img/touki-tqs-title.png" @click="clickMenuAction('ログアウト', '')"></v-img>
      </div>
    </v-app-bar>
    <!-- その他 -->
    <comMessageConfirm :msg="dlgMsgLogoutConfirm.msg" :isOpen="dlgMsgLogoutConfirm.isOpen" :doYes="dlgMsgLogoutConfirm.doYes" :doNo="dlgMsgLogoutConfirm.doNo" />
  </div>
</template>

<script>
// import Constants from '../common/constants';
export default {
  props: ["propScreenTitle", "propMenuInfo1", "propMenuInfo2", "propSrcScreenId"],
  data() {
    return {
      drawer: false,
      menuInfoList: [
        { name: "ホーム", icon: "mdi-home-circle-outline", 
          link: this.$router.resolve({ name: "MTO100", params: {srcScreenId: this.propSrcScreenId} }).href },
        { name: "ユーザ登録", icon: "mdi-account-reactivate-outline", 
          link: this.$router.resolve({ name: "MTO200", params: {srcScreenId: this.propSrcScreenId} }).href },
        { name: "ユーザ一覧検索・編集", icon: "mdi-account-search-outline", 
          link: this.$router.resolve({ name: "MTO220", params: {srcScreenId: this.propSrcScreenId} }).href },
        { name: "申込一覧検索・編集", icon: "mdi-file-search-outline", 
          link: this.$router.resolve({ name: "MTR100", params: {srcScreenId: this.propSrcScreenId} }).href },
        { name: "問合せ一覧検索", icon: "mdi-email-search-outline", 
          link: this.$router.resolve({ name: "MTQ100", params: {srcScreenId: this.propSrcScreenId} }).href },
        { name: "ログアウト", icon: "mdi-logout-variant", 
          link: this.$router.resolve({ name: "MTA100", params: {srcScreenId: this.propSrcScreenId} }).href }
      ],
      transViewPath: "",
      dlgMsgLogoutConfirm: {
        msg: this.$i18n.t('msg.wrn.ps010'),
        isOpen: false,
        doYes: () => {
          // 認証初期化
          this.$store.commit("authcUser/resetState");
          // 次画面遷移
          this.$router.push(this.$router.resolve({ name: "MTA100" }).href);
        },
        doNo: () => {
          this.dlgMsgLogoutConfirm.isOpen = false;
        },
      },
    }
  },
  computed: {
    toolbarTitle() {
      console.log(this.propScreenTitle);
      return this.propScreenTitle;
    },
    menuInfo1() {
      return this.propMenuInfo1;
    },
    menuInfo2() {
      return this.propMenuInfo2;
    },
    sourceScreenUrl() {
      return this.propSrcScreenId;
    },
  },
  methods: {
    /**
     * メニュー押下
     */
    clickMenuAction(name, action) {
      // 遷移先URL
      this.transViewPath = action;
      if (name == 'ログアウト') {
        // ログアウト
        this.dlgMsgLogoutConfirm.isOpen = true;
      } else {
        // ホーム, アカウント設定, その他
        this.$router.push(this.transViewPath).catch(()=>{});
      }
    }
  },
};
</script>

<style scoped>
.scn-name {
  font-size: x-large;
  color: #0D47A1;
}
.usr-name {
 font-size: medium;
  color: #000000;
}
.menu-title {
  font-size: 0.8em !important;
  color: #000000;
}

@media screen and (max-width: 750px) {
  .scn-name {
    font-size: medium;
  }
}
</style>